import React, { useState, useEffect, forwardRef } from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import ImageUploading from 'react-images-uploading';
import Refreshing from '../components/Refreshing';

import { MdOutlineAddPhotoAlternate } from "react-icons/md";

import ImageCropModal from '../modals/ImageCropModal';

import * as dayjs from 'dayjs'

import * as apiComms from '../apiComms';

const PromotionAddOrEditModal = (props) => {

  const [ promotionName, setPromotionName ] = useState('');
  const [ promotionLinkUrl, setPromotionLinkUrl ] = useState(global.DEFAULT_NEW_PROMOTION_LINK_URL);
  const [ displayFrom, setDisplayFrom ] = useState(new Date());
  const [ displayTo, setDisplayTo ] = useState(new Date());
  const [ images, setImages ] = useState([]);
  const [ isRefreshingView, setIsRefreshingView ] = useState(props.isRefreshing);
  const [ refreshingMessage, setRefreshingMessage ] = useState('Refreshing...');
  const [ isImageCropModalVisible, setIsImageCropModalVisible ] = useState(false);
  const [ cropImage, setCropImage ] = useState(null);
  const [ isPreloadedImage, setIsPreloadedImage ] = useState(false);
  const [ windowHeight, setWindowHeight ] = useState(100);

  useEffect(() => {

    setWindowHeight(window.innerHeight);

    if (props.hasOwnProperty('existingPromotion')) {
      const existingItem = props.existingPromotion;

      setPromotionName(existingItem.title);
      setPromotionLinkUrl(existingItem.callToActionUrl);

      let _displayFrom = dayjs(existingItem.displayFrom*1000);
      setDisplayFrom(_displayFrom.toDate());

      let _displayTo = dayjs(existingItem.displayTo*1000);
      setDisplayTo(_displayTo.toDate());

      //const img = await getImage(existingItem.imageUrl);

      loadImage(existingItem.imageUrl);

      //setImages([ img ]);
    }
    else {
      const now = new Date();
      setDisplayFrom(now); // Today
      let threeMonthsFromNow = new Date();
      threeMonthsFromNow.setDate(now.getDate()+90);
      setDisplayTo(threeMonthsFromNow);
    }
  }, []);

  const loadImage = async (imgUrl) => {
    setImages([ imgUrl ]);
    
    const m = /^.*\/(.*?\.png)$/.exec(imgUrl);
    if (m) {
      const imageWithoutDirectoryPrefix = m[1];
      const res = await apiComms.getImage(imageWithoutDirectoryPrefix);
      console.log(1);
      if (res.isErr) {
        alert('Error loading Image: '+res.errMsg);
      }
      else {
        const base64Image = res.response.image;
        const base64ImageWithHeader = 'data:image/png;base64,'+base64Image;
        setImages( [ { data_url : base64ImageWithHeader } ] );
        setIsPreloadedImage(true);
      }
    }
  };



  const onImageChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    setIsPreloadedImage(false);
  };

  const handleSubmitButtonPress = async () => {
    if (!isPreloadedImage) {
      // We need to process and crop the image
      setRefreshingMessage('Uploading Image...');
      setIsRefreshingView(true);
      const imageObject = images[0];
      const image_data = imageObject.data_url;
      setIsRefreshingView(false);
      setCropImage(image_data);
      setIsImageCropModalVisible(true);
    }
    else {
      // Image was already previously cropped and
      // loaded so no cropping required

      let promotionId = null;
      if (props.existingPromotion.hasOwnProperty('promotionId')) {
        promotionId = props.existingPromotion.promotionId;
      }
      else if (props.existingPromotion.hasOwnProperty('couponId')) {
        promotionId = props.existingPromotion.couponId;
      }
      const promotionItem = {
        promotionId : promotionId,
        title : promotionName,
        linkUrl : promotionLinkUrl,
        imageUrl : props.existingPromotion.imageUrl,
        displayFrom : (displayFrom.getTime() / 1000),
        displayTo : (displayTo.getTime() / 1000)
      };
      props.handleSubmitButtonPress(promotionItem);
    }
  };

  const handleSubmitImageCropCompletedEvent = async (croppedImageUrl) => {
    const FUNCTION = 'handleAddNewImageCropCompletedEvent';

    // Hide the Crop-Image Modal
    setIsImageCropModalVisible(false);

    let promotionItem = {
      title : promotionName,
      linkUrl : promotionLinkUrl,
      imageUrl : croppedImageUrl,
      displayFrom : (displayFrom.getTime() / 1000),
      displayTo : (displayTo.getTime() / 1000)
    };
    if (props.hasOwnProperty('existingPromotion') && props.existingPromotion.hasOwnProperty('promotionId')) {
      promotionItem.promotionId = props.existingPromotion.promotionId;
    } 
    else if (props.hasOwnProperty('existingPromotion') && props.existingPromotion.hasOwnProperty('couponId')) {
      promotionItem.promotionId = props.existingPromotion.couponId;
    }
    props.handleSubmitButtonPress(promotionItem);
  };


  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      ref = { ref }
      value = { value }
      onClick={ onClick }
      dateFormat="dd/MM/YYYY"
      style={{
        borderRadius: 5,
        border: "1px solid #cccccc",
        padding: "6px 10px",
        width : '100%'
      }}
      readOnly
      {...props}
    />
  ));

  return (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', zIndex: 20000, width : '100%', height : '100%' }}>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%', height : '100%', backgroundColor : 'black', opacity : 0.5 }}></div>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%' }}>
      <div className="modal-dialog modal-lg" role="document" style={{ width : '80%', backgroundColor : 'white', height : { windowHeight }, maxHeight : { windowHeight } }}>
        { isImageCropModalVisible ? (
          <ImageCropModal imgsrc={ cropImage } handleCancelPress={ () => { setIsImageCropModalVisible(false); }} handleImageCropCompletedEvent = { (croppedImageUrl) => { handleSubmitImageCropCompletedEvent(croppedImageUrl); }} aspect = { 1/1 } />
        ) : null }
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{ props.modalTitle }</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick = { props.handleCancelPress }
                onPress = { props.handleCancelPress }>
              </button>
            </div>
            <div className="modal-body">

              { props.isRefreshing ? (
                <Refreshing message={ refreshingMessage } />
              ) : null }

              { !props.isRefreshing ? (
                <>
                  <div style={{ overflowY : 'scroll', display : 'flex', flexDirection : 'column', flexGrow : 10, paddingLeft: 20, paddingRight : 20 }}>
                      <div className="mb-3 col-12">
                        <label htmlFor="name" className="form-label">{ props.modalKeyword } Name</label>
                        <input type="text" className="form-control" id="name" aria-describedby="name" placeholder={ props.modalKeyword+' Name ' } value={ promotionName } onChange = { (event) => { setPromotionName(event.target.value); }} />
                        <div id="nameHelper" className="form-text">The name for the promotion item (only used for analytics).</div>
                      </div>

                    
                      { props.isLinkUrl ? (
                        <div className="mb-3 col-12">
                          <label htmlFor="url" className="form-label">{ props.modalKeyword } Link URL</label>
                          <input type="text" className="form-control" id="url" aria-describedby="name" placeholder={ props.modalKeyword+' Url' } value={  promotionLinkUrl } onChange = { (event) => { setPromotionLinkUrl(event.target.value); }} />
                          <div id="urlHelper" className="form-text">The URL for the promotion item.</div>
                        </div>
                      ) : null }

                      <div className="mb-3 col-12">
                        <div>{ props.modalKeyword } Image</div>
                        <div>
                          <ImageUploading
                            value={images}
                            onChange={onImageChange}
                            maxNumber={ 1 }
                            dataURLKey="data_url"
                          >
                            {({
                              imageList,
                              onImageUpload,
                              onImageRemoveAll,
                              onImageUpdate,
                              onImageRemove,
                              isDragging,
                              dragProps,
                            }) => (
                              // write your building UI
                              <div className="upload__image-wrapper">
                                { (imageList.length == 0) ? (
                                  <>
                                  {/**
                                  <button
                                    style={isDragging ? { color: 'red' } : undefined}
                                    onClick={onImageUpload}
                                    {...dragProps}
                                  >
                                    Click or Drop here
                                  </button>
                                  **/}

                                  <div>
                                    <center>
                                    <div style={{ width : 130, height : 130, borderRadius: 10, overflow : 'hidden', backgroundColor : '#e0e0e0' }}>
                                      <div style={{ width : 130, height : 130 }} onClick={ onImageUpload } {...dragProps} >
                                        <MdOutlineAddPhotoAlternate style={{ width : '100%', height : '100%', paddingLeft : 10, paddingRight : 10, color : '#039be5' }}/>
                                      </div>
                                    </div>
                                    <div style={{ width : '100%', justifyContent : 'center', display : 'flex', fontSize: 12 }}>Drag or&nbsp;<a className="waves-effect waves-light btn-small blue" onClick={ onImageUpload } style={{ cursor : 'pointer' }}>Upload</a>&nbsp;Image</div>
                                    </center>
                                  </div>
                  
                                    
                                    
                                  </>
                                ) : null }
                                {/**
                                <button onClick={onImageRemoveAll}>Remove all images</button>
                                **/}
                                {imageList.map((image, index) => (
                                  <div key={index} className="image-item">
                                    <img src={image['data_url']} alt="" width="100" />
                                    <div className="image-item__btn-wrapper">
                                      {/**
                                      <a className="waves-effect waves-light btn-small blue" onClick={() => onImageUpdate(index)}>Update</a>
                                      **/}
                                      <a className="waves-effect waves-light btn-small blue" onClick={() => onImageRemove(index)}>Remove</a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </ImageUploading>
                        </div>
                      </div>

                      
                      <div className="mb-3 col-12">
                        <label htmlFor="displayfrom" className="form-label">{ props.modalKeyword } Display From</label><br />
                        <DatePicker customInput={<CustomDateInput />} id="displayfrom" selected={displayFrom} onChange={(date) => setDisplayFrom(date)} dateFormat="dd/MM/YYYY" />
                        <div id="displayFromHelper" className="form-text">The date that the promotion is visiable in the app from.</div>
                      </div>

                      <div className="mb-3 col-12">
                        <label htmlFor="displayto" className="form-label">{ props.modalKeyword } Display To</label><br />
                        <DatePicker customInput={<CustomDateInput />} id="displayTo" selected={displayTo} onChange={(date) => setDisplayTo(date)} dateFormat="dd/MM/YYYY" />
                        <div id="displayToHelper" className="form-text">The date that the promotion is visiable in the app to.</div>
                      </div>
                  </div>
                </>
              ) : null }
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => { props.handleCancelPress(); }}
                onPress={() => { props.handleCancelPress(); }}>Cancel</button>
              { (promotionName.trim() == '' || images.length == 0 || (props.isLinkUrl && (promotionLinkUrl.indexOf('//') == -1 || promotionLinkUrl.indexOf('.') == -1))) ? (
                <button disabled type="button" className="btn btn-primary disabled" style={{ backgroundColor : '#cccccc', borderColor : '#aaaaaa' }} aria-disabled="true">{ props.submitButtonText }</button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={ () => { handleSubmitButtonPress(); }}
                  onPress={ () => { handleSubmitButtonPress(); }}
                >{ props.submitButtonText }</button>
              ) }
                  
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default PromotionAddOrEditModal;
